export default {
  env: { // 环境判断
    beta: {
      domain: 'cd.cy.test.meituan.com', // 当前域名
      serverDomain: 'cd.cy.test.meituan.com', // 当前后端域名
    },
    prd: {
      domain: 'pc.meituan.com',
      serverDomain: 'pc.meituan.com',
    },
  },
  module: { // 模块判断
    default: {
      action: '', // 后端模块，用于页面跳转
      ajax: '', // 接口地址，用户'ajax'请求
      inEcom: true, // 是否在ECOM中
      oldModule: '/shop',
    },
    cloudmessage: {
      action: '/cm',
      ajax: '/cm',
      inEcom: false,
      beta: {
        serverDomain: 'odm.51ping.com',
      },
      prd: {
        serverDomain: 'odm.dianping.com',
      },
    },
    messagedetail: {
      ajax: '/cm',
      beta: {
        serverDomain: 'odm.51ping.com',
      },
      prd: {
        serverDomain: 'odm.dianping.com',
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/lib/config.js